
// src/web/components/search-drawer.jsx

import React from 'react'
import connect from '../../connects/search-drawer'
import Input from './compact-input.jsx'
import {
  List,
  ListItem,
  ListCheckbox,
  ListDivider,
  ListSubHeader,
} from 'react-toolbox/lib/list'
import Drawer from 'react-toolbox/lib/drawer'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import DatePicker from './date-picker.jsx'
import NotificationBadge, { Effect } from 'react-notification-badge';
import moment from 'moment'
import ConfirmDialog from './confirm-dialog.jsx'
import Avatar from 'react-toolbox/lib/avatar'
import Theme from './themes/search-drawer.scss'
import { mergeArray } from '../../helpers/store'

class SearchDrawer extends React.Component {

  render() {
    const {
      t,
      ui,
      active,
      group,
      onClose,
      isFetching,
      preservedQueries,
      submitQuery,
      selectPreservedQuery,
      deletePreservedQuery,
      showUserSelectionDialog,
      updateUI,
      user,
      clearSearchQuery
    } = this.props

    return (
      <Drawer type='right' active={active} onOverlayClick={onClose} theme={Theme} className='search_drawer'>
        <form onSubmit={(ev)=> submitQuery(this.props, ev)}>
          <div style={{ display: 'flex', padding: 5 }}>
            <Input hasFocus className="fluid" hint={t('label:検索キーワード')} value={ui.queryText} onChange={(value)=> updateUI({ queryText: value })}/>
            <IconButton icon="close" onClick={() => clearSearchQuery(this.props)}/>
            <IconButton icon="search" type="submit" primary />
          </div>
          <List>
            {preservedQueries && preservedQueries.length > 0 &&
              <ListSubHeader caption={t('label:保存された検索条件')} />
            }
            {preservedQueries && preservedQueries.length > 0 && _.map(preservedQueries, (query)=> 
              <ListItem key={query.query_id}
                  theme={Theme}
                  className='search_text_ellipsis'
                  selectable
                  caption={query.name}
                  onClick={()=> selectPreservedQuery(this.props, query)} 
                  avatar={<Avatar icon="search" className='searchIcon' theme={Theme} />}
                  rightActions={[
                    <IconButton icon='close' key='icon' onClick={()=>  updateUI({ deleteConfirm: true, deleteQuery: query, deleteQueryName: query.name })}
                    />]}>
              </ListItem>
            )}
            <ListDivider />
            <ListItem selectable
                  caption={
                    <span>
                      {t('label:ユーザで絞り込み')}
                      <NotificationBadge count={ui.users && ui.users.length || undefined}
                          containerStyle={{ top: '-18px', left: '-10px' }} 
                          effect={Effect.SCALE}/>
                    </span>
                  }
                  leftIcon="people"
                  onClick={()=> {
                    showUserSelectionDialog(
                      t('label:ユーザで絞り込み'),
                      true,
                      group && group.group_id != 'home' && 'GROUP_MEMBERS' || 'ACCOUNT_MEMBERS',
                      group && group.group_id != 'home' && group || undefined, 
                      ui.users && ui.users,
                      (users)=> updateUI({
                        users: mergeArray('user_id', [], users),
                      })
                    )}} />
            <ListCheckbox caption={t('label:すべての投稿種別')} checked={ui.category == 'all'} onChange={()=> updateUI({ category: 'all' })} />
            <ListCheckbox caption={t('label:日報のみ')} checked={ui.category == 'diary'} onChange={()=> updateUI({ category: 'diary' })} />
            <ListCheckbox caption={t('label:KPIのみ')} checked={ui.category == 'kpi'} onChange={()=> updateUI({ category: 'kpi' })} />
            <ListCheckbox caption={t('label:ノートのみ')} checked={ui.category == 'memo'} onChange={()=> updateUI({ category: 'memo' })} />
            <ListDivider />
            <ListSubHeader caption={t('label:オプション')} />
            <ListCheckbox caption={t('label:添付ファイル付き')} checked={ui.files_attached} onChange={()=> updateUI({ files_attached: !ui.files_attached })} />
            <ListCheckbox caption={t('label:いいねした投稿')} checked={ui.liked_by? true: false} onChange={()=> updateUI({ liked_by: ui.liked_by ? undefined : user.user_id })} />
            <ListItem 
                caption={
                  <DatePicker
                        label={t('label:日付の選択')}
                        inputFormat={(date)=> date && t('label:より後の投稿', { reported_at: moment(date).format('LLLL') }) || ''}
                        value={ui.reported_at && moment(ui.reported_at).toDate() || undefined}
                        maxDate={moment().toDate()}
                        onChange={(date)=> updateUI({ reported_at: moment(date) })}
                        onDismiss={()=> updateUI({ reported_at: undefined })} />} />
          </List>
          <Button primary raised
              style={{ width: '100%' }}
              icon="search"
              label={t('label:検索')}
              type="submit" />
        </form>
        <ConfirmDialog open={ui.deleteConfirm}
              title={t('label:検索条件を削除してもいいですか', { name: ui.deleteQueryName })}
              description={t('label:この操作は取り消せません')}
              yesLabel={t('label:削除')}
              noLabel={t('label:取り消し')}
              onYes={()=> { updateUI({ deleteConfirm: false }); deletePreservedQuery(ui.deleteQuery, true) }}
              onNo={()=> updateUI({ deleteConfirm: false, deleteQuery: undefined, deleteQueryName: undefined })} />
      </Drawer>
    )
  }
}

export const RawSearchDrawer = SearchDrawer
export default connect(SearchDrawer)



// WEBPACK FOOTER //
// ./src/web/components/search-drawer.jsx